import { ApiService } from "@/services/api/ApiService";
import { AiUsagePeriod, AiUsageReport } from "@/types/admin/ai-usage";

export class AiUsageService {
  static async report(period: AiUsagePeriod): Promise<AiUsageReport> {
    return ApiService.invoke({ resource: "ai-usage", action: "report", data: { period } });
  }

  static async syncPrices(): Promise<{ models: number; backfilled: number }> {
    return ApiService.invoke({ resource: "ai-usage", action: "sync-prices" });
  }
}
